import request from '@/utils/request'

// 查询证书列表
export function listCertificate(query) {
    return request({
        url: '/h5/certificate/list',
        method: 'get',
        params: query
    })
}

//证书详情
export function certificateById(id) {
    return request({
        url: '/h5/certificate/' + id,
        method: 'get',
    })
}


// 新增用户证书
export function addUserCertificate(data) {
    return request({
        url: '/h5/certificate',
        method: 'post',
        data: data
    })
}
